import React, { useContext } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { UserContext } from "../../App";
import logo from "../../images/Logo.png";

const NavBar = () => {
    const [loggedInUser] = useContext(UserContext);

    return (
        <Navbar expand="lg" className="mx-4">
            <Navbar.Brand href="/home">
                <img src={logo} alt="" style={{ width: "120px" }} />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto">
                    <NavLink to="/home" className="mr-4 font-weight-bold text-dark">
                        Home
                    </NavLink>
                    <NavLink to="/destination" className="mr-4 font-weight-bold text-dark">
                        Destination
                    </NavLink>
                    <NavLink to="/blog" className="mr-4 font-weight-bold text-dark">
                        Blog
                    </NavLink>
                    <NavLink to="/contact" className="mr-4 font-weight-bold text-dark">
                        Contact
                    </NavLink>
                    <p className="font-weight-bold text-dark">{loggedInUser.name}</p>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default NavBar;
